import { CSSObject, styled } from 'libs/ui/styled';

export const ContainerStyled = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',

  '.MuiTabs-root': {
    overflow: 'visible',

    '.MuiTabs-scroller': {
      overflow: 'visible !important',
    },
    '.MuiTabs-indicator': {
      bottom: -14,
    } as CSSObject,

    '.MuiTab-root': {
      ...theme.typography.body,
    } as CSSObject,
  } as CSSObject,
}));
